import { render, staticRenderFns } from "./testcharts.vue?vue&type=template&id=05e788ca&scoped=true"
import script from "./testcharts.vue?vue&type=script&lang=js"
export * from "./testcharts.vue?vue&type=script&lang=js"
import style0 from "./testcharts.vue?vue&type=style&index=0&id=05e788ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e788ca",
  null
  
)

export default component.exports